import { MouseEvent, useRef, useState } from 'react';

export const useActionsMenu = () => {
  const [, setActionsOpen] = useState(false);
  const anchorRef = useRef<
    HTMLDivElement | HTMLElement | HTMLButtonElement | HTMLImageElement | SVGSVGElement | null
  >(null);

  const handleOpenActionsMenu = (e: MouseEvent<SVGSVGElement>) => {
    anchorRef.current = e.currentTarget;
    setActionsOpen(true);
  };

  const handleCloseActionsMenu = () => {
    setActionsOpen(false);
    anchorRef.current = null;
  };

  return {
    handleCloseActionsMenu,
    handleOpenActionsMenu,
    anchorRef,
  };
};
